import type {AddComponentTypeOptions} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {POSTERMYWALL_FORM_SPACER_TYPE} from '@FormMakerReact/components/postermywall-form-spacer/postermywall-form-spacer';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {POSTERMYWALL_FIRST_NAME_INPUT_TYPE} from '@FormMakerReact/components/postermywall-first-name-input/postermywall-first-name-input';

export const POSTERMYWALL_FIRST_NAME_BOX_TYPE = 'postermywall-first-name-box';

export const POSTERMYWALL_FIRST_NAME_BOX: AddComponentTypeOptions = createBaseBoxComponent({
  boxType: POSTERMYWALL_FIRST_NAME_BOX_TYPE,
  dataMarkerAttribute: 'data-is-pmw-form-first-name-box',
  components: [
    {type: POSTERMYWALL_FORM_SPACER_TYPE},
    {type: POSTERMYWALL_FORM_TEXT_TYPE, content: `<strong>First Name${asteriskHtml()}</strong>`},
    {type: POSTERMYWALL_FIRST_NAME_INPUT_TYPE},
  ],
});
